export const arrayBufferResponseHandler = (response: Response) => {
  return response.arrayBuffer();
};
